<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="form-group form-inline d-flex">
          <label for="membersch" class="col-sm-3 control-label">Email</label>
          <div class="mr-3">
            <input
              type="text"
              id="membersch"
              name="membersch"
              placeholder="Email"
              class="form-control"
              v-model="membersch"
            />
          </div>
          <b-button variant="danger" @click.prevent="banMember" class="gobutton"
            >Ban</b-button
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="row justify-content-center">
      <div class="col-md-12 mt-3">
        <b-container fluid>
          <b-row>
            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <div v-if="items != null">
                Total Banned Member: <b>{{ items.length }}</b> | Current Row
                Count: <b>{{ totalRowCnt }}</b>
              </div>
            </b-col>
          </b-row>
          <hr />
          <!-- User Interface controls -->
          <b-row>
            <b-col sm="4" md="4" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            show-empty
            striped
            hover
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :busy="loading"
            :keyword="keyword"
            :filter="filter"
            :filterIncludedFields="filterOn"
            v-model="visibleRows"
          >
            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                @click.prevent="removeBanned(row.item.cardid)"
                class="mr-1"
                variant="secondary"
              >
                <i class="fas fa-trash-alt"></i>
              </b-button>
            </template>
          </b-table>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import {
  packageTypeFull,
  packageDurationFull,
  getPackageFull,
} from "./../js/utils/datamanip.js";
export default {
  data() {
    return {
      visibleRows: [],
      loading: false,
      isBusy: false,
      items: null,
      start_date: null,
      end_date: null,
      keyword: "",
      membersch: "",
      //dataArray: null,
      /*filters: {
          cardid: "",
        },*/
      fields: [
        {
          key: "cardid",
          label: "ID",
        },
        {
          key: "firstname",
          label: "First Name",
        },
        {
          key: "lastname",
          label: "Last Name",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "banned_date",
          label: "Banned Date",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 30,
      pageOptions: [30, 60],
      filter: null,
      filterOn: ["cardid", "email"],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    totalRowCnt() {
      return this.visibleRows.reduce((accum, item) => {
        return accum + 1;
      }, 0.0);
    },
    /* items() {
        return this.keyword
          ? this.dataArray.filter(
              (item) =>
                item.firstname.includes(this.keyword) ||
                item.lastname.includes(this.keyword)
              // item.ref_number.includes(this.keyword)
            )
          : this.dataArray;
      }, */
  },
  mounted() {
    this.listMembership();
  },
  methods: {
    searchData() {},
    async listMembership() {
      this.loading = true;
      await axios.get("/api/members/bannedlist").then((response) => {
        //console.log(response.data);
        this.items = response.data;
        //this.dataArray = response.data.data;
        this.totalRows = this.items.length;
        //console.log(response.data);
        this.loading = false;
      });
    },
    async banMember() {
      await axios
        .post("/api/members/addbanned", {
          email: this.membersch,
        })
        .then((response) => {
          if (response.data.status == "SUCCESS") {
            this.listMembership();
          }
        });
    },
    async removeBanned(cardid) {
      await axios
        .get("/api/members/removebanned/" + cardid)
        .then((response) => {
          if (response.data.status == "SUCCESS") {
            this.listMembership();
          }
        });
    },
    getLocalPackageFull(key) {
      return getPackageFull(key);
    },
    getPackageTypeFull(key) {
      return packageTypeFull[key];
    },
    getPackageDurationFull(key) {
      return packageDurationFull[key];
    },
    checkStatus(value) {
      switch (value) {
        case "ACTIVE":
          return "active";
          break;
        case "FREEZE":
          return "freeze";
          break;
        case "INACTIVE":
          return "inactive";
        case "LOCK":
          return "lock";
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.gobutton {
  width: 80px;
  font-weight: bold;
}
table {
  font-size: 0.9em;
}
.active {
  /*font-size: 1.5em;*/
  color: green;
  font-weight: bold;
}
.freeze {
  /*font-size: 1.5em;*/
  color: blue;
  font-weight: bold;
}
.inactive {
  /*font-size: 1.5em;*/
  color: red;
  font-weight: bold;
}
.lock {
  /*font-size: 1.5em;*/
  color: purple;
  font-weight: bold;
}
</style>
